import { KnownScript, ScriptInfoLike, ScriptInfo } from "@ckb-ccc/core";
import { ClientJsonRpc, ClientJsonRpcConfig } from "@ckb-ccc/core";
import { DEVNET_SCRIPTS } from "./clientDevnet";

/**
 * @public ClientPublicDevnet is a client for the CKB public devnet.
 */
export class ClientPublicDevnet extends ClientJsonRpc {
  constructor(
    private readonly config?: ClientJsonRpcConfig & {
      url?: string;
      scripts?: Record<KnownScript, ScriptInfoLike | undefined>;
    },
  ) {
    super(config?.url ?? "http://127.0.0.1:8114", {
      ...config,
      fallbacks: config?.fallbacks ?? ["http://127.0.0.1:8114"],
    });
  }

  get addressPrefix(): string {
    return "ckt";
  }

  async getKnownScript(script: KnownScript): Promise<ScriptInfo> {
    return { ...DEVNET_SCRIPTS[script] };
  }
}
